import React from "react";
import FormGroup from "app/Components/Form/FormGroup.component";

export default function FilterForm({ fields, form, onChange, onReset, handleDateRange, startDate, endDate, multiFieldDateRange }) {
  return (
    <div className="row">
      {fields?.map((field, index) => {
        return <FormGroup key={index} field={field} form={form} onChange={onChange} handleDateRange={(dates) => handleDateRange(dates, field.name)} startDate={multiFieldDateRange ? form[field.name]?.startDate || null : startDate} endDate={multiFieldDateRange ? form[field.name]?.endDate || null : endDate} />;
      })}
      <div className="col-12 mt-3 text-center">
        <button className="btn btn-primary mx-2" type="button" onClick={onReset}>
          Reset
        </button>
      </div>
    </div>
  );
}
